/**
 * @file TransferQuantityField.tsx
 * @description Поле «Количество» в форме строки перемещения (довесок
 * phase19.24 этап 0).
 *
 * Вынесено из `TransferItemForm` отдельной секцией: форма и так на пределе
 * размера, а у поля своя логика — внутри склада партия переезжает целиком
 * (поле read-only), между складами вводится количество, и там же живёт
 * подсказка/ошибка под полем.
 *
 * Перемещают пачки: `GET /admin/wms/stock` отдаёт фасовку без `saleQuantity`
 * и `saleUnit`, развес отличить нельзя — считаем штуками (реестр `qty-input`:
 * шаг 1, целые).
 */

import { WmsFieldLabel } from "../WmsFieldLabel";
import { qtyInputProps } from "../../../lib/qty-input";

/** Единица счёта строки перемещения — та же, что в `TransferItemRow`. */
export const TRANSFER_QTY_UNIT = "шт";

interface Props {
  /** BIN — переезд внутри склада: количество не вводится. */
  intraWarehouse: boolean;
  value: string;
  /** Остаток выбранной партии — подпись «вся партия». */
  lotQuantity: number | null;
  /** Текст ошибки под полем; null — показываем обычную подсказку. */
  error: string | null;
  onChange: (next: string) => void;
}

export function TransferQuantityField({
  intraWarehouse,
  value,
  lotQuantity,
  error,
  onChange,
}: Props) {
  return (
    <>
      <WmsFieldLabel label={`Количество, ${TRANSFER_QTY_UNIT}`}>
        {intraWarehouse ? (
          <div className="flex min-h-[var(--control-h,3rem)] items-center rounded-lg border border-on-surface/15 bg-on-surface/4 px-3 tabular-nums text-sm text-on-surface-variant">
            {lotQuantity !== null ? `${lotQuantity} — вся партия` : "вся партия"}
          </div>
        ) : (
          <input
            type="text"
            inputMode={qtyInputProps(TRANSFER_QTY_UNIT).inputMode}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="0"
            className="min-h-[var(--control-h,3rem)] w-full rounded-lg border border-on-surface/15 bg-surface-lowest px-3 text-[length:var(--fs-field,1rem)] tabular-nums"
          />
        )}
      </WmsFieldLabel>

      <p
        className={
          error ? "text-xs text-destructive" : "text-xs text-on-surface-variant"
        }
      >
        {error ??
          (intraWarehouse
            ? "При перемещении в ячейку партия переносится целиком — остаток склада не меняется."
            : "Зарезервированное под заказы увезти нельзя: сначала снимите резерв в заказе.")}
      </p>
    </>
  );
}
